<template>
  <div class="topbar-item">
    <div
      class="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"
      id="kt_quick_user_toggle"
    >
      <span
        class="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1"
      >
        سلام,
      </span>
      <span
        class="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3"
      >
        {{ oidcUser.name ? oidcUser.name : oidcUser.preferred_username }}
      </span>
      <span class="symbol symbol-35 symbol-light-success">
        <img alt="Pic" :src="userAvatar" />
      </span>
    </div>

    <div
      id="kt_quick_user"
      ref="kt_quick_user"
      class="offcanvas offcanvas-right p-10"
    >
      <!--begin::Header-->
      <div
        class="offcanvas-header d-flex align-items-center justify-content-between pb-5"
      >
        <h3 class="font-weight-bold m-0">حساب کاربری</h3>
        <a
          href="#"
          class="btn btn-xs btn-icon btn-light btn-hover-primary"
          id="kt_quick_user_close"
        >
          <i class="ki ki-close icon-xs text-muted"></i>
        </a>
      </div>
      <!--end::Header-->

      <!--begin::Content-->
      <perfect-scrollbar
        class="offcanvas-content pr-5 mr-n5 scroll"
        style="max-height: 90vh; position: relative"
      >
        <!--begin::Header-->
        <div class="d-flex align-items-center mt-5">
          <div class="symbol symbol-100 mr-5 image-input">
            <label
              class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
              data-action="change"
              data-toggle="tooltip"
              title=""
              data-original-title="Change avatar"
            >
              <i class="fa fa-pen icon-sm text-muted"></i>
            </label>
            <img class="symbol-label" :src="userAvatar" alt="" />
            <i class="symbol-badge bg-success"></i>
          </div>
          <div class="d-flex flex-column">
            <a
              href="#"
              class="font-weight-bold font-size-h5 text-dark-75 text-hover-primary"
            >
              {{ oidcUser.preferred_username }}
            </a>
            <div class="text-muted mt-1">{{ oidcUser.name }}</div>
            <div class="navi mt-2">
              <a href="#" class="navi-item">
                <span class="navi-link p-0 pb-2">
                  <span class="navi-icon mr-1">
                    <span class="svg-icon svg-icon-lg svg-icon-primary">
                      <!--begin::Svg Icon-->
                      <inline-svg
                        src="media/svg/icons/Communication/Call.svg"
                      />
                      <!--end::Svg Icon-->
                    </span>
                  </span>
                  <span class="navi-text text-muted text-hover-primary">
                    {{ oidcUser.phone_number }}
                  </span>
                </span>
              </a>
            </div>
            <button class="btn btn-light-primary btn-bold" @click="onLogout">
              خروج
            </button>
          </div>
        </div>
        <!--end::Header-->
        <div class="separator separator-dashed mt-8 mb-5"></div>
        <!--begin::Nav-->

        <!--end::Nav-->
        <div class="separator separator-dashed my-7"></div>
      </perfect-scrollbar>
      <!--end::Content-->
    </div>
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="profileImageDialog"
      width="auto"
      max-width="500"
    >
      <v-card>
        <v-card-title class="d-flex justify-content-between">
          <div class="text-base">ثبت و ویرایش عکس پروفایل</div>

          <v-btn size="sm" small icon @click="closeDialog()" class="float-left">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider> </v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <div class="d-flex justify-content-center align-items-md-center">
                <v-avatar color=" lighten-2" size="250">
                  <v-img
                    max-height="100%"
                    max-width="100%"
                    :src="userAvatar"
                  ></v-img>
                </v-avatar>
              </div>
            </v-col>
            <v-col
              cols="12"
              class="d-flex justify-content-center align-items-md-center"
            >
              <advance-uploader
                crop-type-prop="پرتره"
                title="انتخاب عکس پروفایل"
                :imagesProps="portraitPhotoFile"
                :imageFileIdsProps="portraitPhotoFileId"
                @imagesFileIdsChange="(e) => (portraitPhotoFileId = e)"
                @imagesChange="(e) => (portraitPhotoFile = e)"
                :single-file="true"
                page="profile"
                @getProfilePicture="getProfilePicture"
              ></advance-uploader>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions> </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style lang="scss" scoped>
#kt_quick_user {
  overflow: hidden;
}
.image-input [data-action='change'] {
  cursor: pointer;
  position: absolute;
  right: -10px;
  left: auto !important;
  top: -10px;
}
</style>

<script>
import { LOGOUT } from '@/core/services/store/auth.module';
import KTLayoutQuickUser from '@/assets/js/layout/extended/quick-user.js';
import KTOffcanvas from '@/assets/js/components/offcanvas.js';
import Helper from '@/core/helpers';
import { mapActions, mapGetters, mapState } from 'vuex';
import AdvanceUploader from '@/components/core/AdvanceUploader';
import { RepoFactory } from '@/baseRepository/Factory';
const authRepository = () => RepoFactory.get('auth');
export default {
  name: 'KTQuickUser',
  components: {
    AdvanceUploader,
  },
  data() {
    return {
      list: [
        {
          title: 'Another purpose persuade',
          desc: 'Due in 2 Days',
          alt: '+28%',
          svg: 'media/svg/icons/Home/Library.svg',
          type: 'warning',
        },
        {
          title: 'Would be to people',
          desc: 'Due in 2 Days',
          alt: '+50%',
          svg: 'media/svg/icons/Communication/Write.svg',
          type: 'success',
        },
        {
          title: 'Purpose would be to persuade',
          desc: 'Due in 2 Days',
          alt: '-27%',
          svg: 'media/svg/icons/Communication/Group-chat.svg',
          type: 'danger',
        },
        {
          title: 'The best product',
          desc: 'Due in 2 Days',
          alt: '+8%',
          svg: 'media/svg/icons/General/Attachment2.svg',
          type: 'info',
        },
      ],
      profileImageDialog: false,
      portraitPhotoFile: [],
      portraitPhotoFileId: [],
    };
  },
  mounted() {
    // Init Quick User Panel
    KTLayoutQuickUser.init(this.$refs['kt_quick_user']);
  },
  created() {
    this.getProfilePicture();
  },
  computed: {
    ...mapGetters('oidc', [
      'oidcIsAuthenticated',
      'oidcAuthenticationIsChecked',
      'oidcUser',
      'oidcIdToken',
      'oidcIdTokenExp',
    ]),
    ...mapState(['userAvatar', 'authBaseUrl']),
  },
  methods: {
    ...mapActions('oidc', ['signOutOidc', 'signOutOidcSilent']),
    editProfilePictureDialog() {
      this.profileImageDialog = true;
    },
    closeDialog() {
      this.profileImageDialog = false;
    },
    getProfilePicture() {
      authRepository()
        .getProfilePicture(this.authBaseUrl)
        .then((res) => {
          if (res.status === 200) {
            this.$store.commit('SET_USER_AVATAR', res.data);
          }
        })
        .catch((error) => {});
    },
    ...mapActions('oidc', ['oidcSignInCallback', 'getOidcUser', 'signOutOidc']),
    onLogout() {
      localStorage.removeItem('activeTab');
      this.signOutOidcSilent();
      
    },
    closeOffcanvas() {
      new KTOffcanvas(KTLayoutQuickUser.getElement()).hide();
    },
  },
};
</script>
<style scoped lang="scss">
@media (max-width: 991.98px) {
  .offcanvas {
    margin-top: 55px;
  }
}
</style>
